// select
export const SELECT_SHOP_TRIGGER = 'SELECT_SHOP_TRIGGER';
export const SELECT_SHOP_API_REQUEST = 'SELECT_SHOP_API_REQUEST';
export const SELECT_SHOP_API_SUCCESS = 'SELECT_SHOP_API_SUCCESS';
export const SELECT_SHOP_API_FAILURE = 'SELECT_SHOP_API_FAILURE';
